import { render } from "./ProspectSessions.vue?vue&type=template&id=5eccd582"
import script from "./ProspectSessions.vue?vue&type=script&lang=js"
export * from "./ProspectSessions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__